import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'dn-countdown',
  templateUrl: './dn-countdown.component.html',
  styleUrl: './dn-countdown.component.scss',
  standalone: false,
})
export class DnCountdownComponent implements OnInit, OnDestroy {
  disabledButton = false;
  displayCountdown = false;
  countDown: number;
  timer;

  @Input() descriptionText = '';
  @Input() countdownMsg = 'seconds left';
  @Input() buttonText = 'Click';
  @Input() countDownIntervalTime = 10;

  @Input() countDownSubject: Subject<any>;

  @Output() countDownEnded = new EventEmitter();
  @Output() buttonClicked = new EventEmitter();

  constructor(private readonly detector: ChangeDetectorRef) {}

  ngOnInit() {
    this.countDown = this.countDownIntervalTime;

    this.countDownSubject.subscribe((res) => {
      if (this.displayCountdown) {
        return;
      }
      this.startCountdown();
    });
  }

  intervalTick = () => {
    this.countDown--;
    if (this.countDown <= 0) {
      this.resetTimer();
      this.countDownEnded.emit();
    }
    this.detector.detectChanges();
  };

  buttonClick() {
    this.buttonClicked.emit();
  }

  startCountdown() {
    this.displayCountdown = true;
    this.disabledButton = true;
    this.timer = setInterval(this.intervalTick, 1000);
  }

  resetTimer() {
    this.disabledButton = false;
    this.displayCountdown = false;
    this.countDown = this.countDownIntervalTime;
    clearInterval(this.timer);
  }

  ngOnDestroy(): void {
    if (this.countDownSubject) {
      this.countDownSubject.unsubscribe();
    }
  }
}
